import { Colors } from '@ab-core/colors';
import { RADIUS } from '@ab-core/radius';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const List = styled.ul`
    width: 100%;
    li {
        display: flex;
        padding: 20px 0;
        border-bottom: 1px solid ${Colors.gray30};
    }
`;

export const Border = styled.div`
    width: 100%;
    position: relative;
    background-color: white;
    padding: ${SPACING.MEDIUM};
    border: 1px solid ${Colors.gray30};
    border-radius: ${RADIUS.ROUNDED};
    margin: ${SPACING.SMALL_2} 0;
`;
